"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortTasks = sortTasks;
exports.getIllustrationForAction = getIllustrationForAction;
exports.getTaskDetailDescription = getTaskDetailDescription;
exports.trackOnboardingEvent = trackOnboardingEvent;
exports.getTaskRouteForAction = getTaskRouteForAction;
exports.getTaskRoute = getTaskRoute;
exports.getTaskRouteWithFallback = getTaskRouteWithFallback;
exports.getTaskPosition = getTaskPosition;
exports.getTask = getTask;
exports.getPreviousTask = getPreviousTask;
exports.getNextTask = getNextTask;
exports.getTasksInformation = getTasksInformation;
exports.formatIdentityVerificationTask = void 0;

var _react = _interopRequireDefault(require("react"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _additional_documents = _interopRequireDefault(require("../../../public/images/onboarding/tasks/additional_documents.svg"));

var _administrative_details = _interopRequireDefault(require("../../../public/images/onboarding/tasks/administrative_details.svg"));

var _emergency_contact = _interopRequireDefault(require("../../../public/images/onboarding/tasks/emergency_contact.svg"));

var _home_address = _interopRequireDefault(require("../../../public/images/onboarding/tasks/home_address.svg"));

var _payment_details = _interopRequireDefault(require("../../../public/images/onboarding/tasks/payment_details.svg"));

var _review_compensation = _interopRequireDefault(require("../../../public/images/onboarding/tasks/review_compensation.svg"));

var _user_details = _interopRequireDefault(require("../../../public/images/onboarding/tasks/user_details.svg"));

var _verify_identity = _interopRequireDefault(require("../../../public/images/onboarding/tasks/verify_identity.svg"));

var _routes = require("../../constants/routes");

var _amplitude = require("../analytics/amplitude");

var _events = require("../analytics/amplitude/events");

var _constants = require("../identityVerification/constants");

var _general = require("../../helpers/general");

var _constants2 = require("./constants");

var _tasksConfig;

var __jsx = _react["default"].createElement;

function sortTasks(tasks) {
  var taskActionsOrder = [_constants2.onboardingTask.USER_DETAILS, _constants2.onboardingTask.ADMINISTRATIVE_DETAILS, _constants2.onboardingTask.HOME_ADDRESS, _constants2.onboardingTask.EMERGENCY_CONTACT, _constants2.onboardingTask.PAYMENT_DETAILS, _constants2.onboardingTask.VERIFY_IDENTITY, _constants2.onboardingTask.ADDITIONAL_DOCUMENTS, _constants2.onboardingTask.REVIEW_COMPENSATION];
  return taskActionsOrder.reduce(function (sortedList, action) {
    var actionTask = tasks.find(function (task) {
      return task.action === action;
    });

    if (actionTask) {
      sortedList.push(actionTask);
    }

    return sortedList;
  }, []);
}

var tasksConfig = (_tasksConfig = {}, (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.USER_DETAILS, {
  pic: _user_details["default"],
  description: 'Let’s start with the basics.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_PERSONAL_DETAILS_INFORMATION_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_PERSONAL_DETAILS_INFORMATION_ROUTE
  },
  trackingEvent: _events.onboardingEvents.PERSONAL_PROFILE_ADDED
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.ADMINISTRATIVE_DETAILS, {
  pic: _administrative_details["default"],
  description: 'This information is for tax and compliance purposes.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_ADMINISTRATIVE_DETAILS_INFORMATION_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_ADMINISTRATIVE_DETAILS_INFORMATION_ROUTE
  },
  trackingEvent: _events.onboardingEvents.ADMINISTRATIVE_DETAILS_ADDED
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.HOME_ADDRESS, {
  pic: _home_address["default"],
  description: 'Please provide your full home address.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_HOME_ADDRESS_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_HOME_ADDRESS_ROUTE
  },
  trackingEvent: _events.onboardingEvents.HOME_ADDRESS_ADDED
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.EMERGENCY_CONTACT, {
  pic: _emergency_contact["default"],
  description: 'In case of emergency, we will contact this person.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_EMERGENCY_CONTACT_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_EMERGENCY_CONTACT_ROUTE
  },
  trackingEvent: _events.onboardingEvents.EMERGENCY_CONTACT_ADDED
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.PAYMENT_DETAILS, {
  pic: _payment_details["default"],
  description: 'Please enter your banking information.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_PAYMENT_DETAILS_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_PAYMENT_DETAILS_ROUTE
  },
  trackingEvent: _events.onboardingEvents.BANK_DETAILS_ADDED
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.VERIFY_IDENTITY, {
  pic: _verify_identity["default"],
  description: 'This helps us keep the platform safe.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_VERIFY_IDENTITY_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_VERIFY_IDENTITY_ROUTE
  },
  trackingEvent: _events.onboardingEvents.IDENTITY_VERIFICATION_DONE
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.ADDITIONAL_DOCUMENTS, {
  pic: _additional_documents["default"],
  description: 'Please upload the requested documents below.',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_ADDITIONAL_DOCUMENTS,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_ADDITIONAL_DOCUMENTS
  },
  trackingEvent: _events.onboardingEvents.DOCUMENTATION_ADDED
}), (0, _defineProperty2["default"])(_tasksConfig, _constants2.onboardingTask.REVIEW_COMPENSATION, {
  pic: _review_compensation["default"],
  description: 'Does everything look correct?',
  route: {
    onboarding: _routes.ONBOARDING_EMPLOYEE_REVIEW_COMPENSATION_ROUTE,
    pendingTask: _routes.PENDING_TASKS_EMPLOYEE_REVIEW_COMPENSATION_ROUTE
  },
  trackingEvent: _events.onboardingEvents.REVIEW_COMPENSATION_DONE
}), _tasksConfig);

function getIllustrationForAction(action) {
  var _config$action;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tasksConfig;
  return ((_config$action = config[action]) === null || _config$action === void 0 ? void 0 : _config$action.pic) || null;
}

function getTaskDetailDescription(action) {
  var _config$action2;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tasksConfig;
  return ((_config$action2 = config[action]) === null || _config$action2 === void 0 ? void 0 : _config$action2.description) || null;
}

function getOnboardingEvent(action) {
  var _config$action3;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : tasksConfig;
  return ((_config$action3 = config[action]) === null || _config$action3 === void 0 ? void 0 : _config$action3.trackingEvent) || null;
}

function trackOnboardingEvent(_ref) {
  var task = _ref.task,
      taskType = _ref.taskType,
      _ref$eventProps = _ref.eventProps,
      eventProps = _ref$eventProps === void 0 ? {} : _ref$eventProps;

  if (!taskType) {
    (0, _general.error)('No taskType on trackOnboardingEvent');
  }

  var event = getOnboardingEvent(task === null || task === void 0 ? void 0 : task.action);

  if (event && (task === null || task === void 0 ? void 0 : task.status) !== _constants2.taskStatus.COMPLETED && taskType === _constants2.taskTypes.ONBOARDING) {
    (0, _amplitude.trackEvent)(event, eventProps);
  }
}

function getTaskRouteForAction(action, taskType) {
  var _config$action4, _config$action4$route;

  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : tasksConfig;
  return ((_config$action4 = config[action]) === null || _config$action4 === void 0 ? void 0 : (_config$action4$route = _config$action4.route) === null || _config$action4$route === void 0 ? void 0 : _config$action4$route[taskType]) || null;
}

function getTaskRoute(task, taskType) {
  return getTaskRouteForAction(task.action, taskType);
}

function getTaskRouteWithFallback() {
  var task = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var taskType = arguments.length > 1 ? arguments[1] : undefined;
  var taskRoute = getTaskRouteForAction(task.action, taskType);
  return taskRoute || (taskType === _constants2.taskTypes.ONBOARDING ? _routes.ONBOARDING_EMPLOYEE_TASKS_ROUTE : _routes.PENDING_TASKS_EMPLOYEE_TASKS_ROUTE);
}

function getTaskPosition(action, tasks) {
  return tasks.findIndex(function (task) {
    return task.action === action;
  });
}

function getTask(action, tasks) {
  return tasks.find(function (task) {
    return task.action === action;
  });
}

function getPreviousTask(action, tasks) {
  var currentTaskIndex = getTaskPosition(action, tasks);
  return tasks[currentTaskIndex - 1];
}

function getNextTask(action, tasks) {
  var currentTaskIndex = getTaskPosition(action, tasks);
  return tasks[currentTaskIndex + 1];
}

function getTasksInformation(_ref2) {
  var totalTasks = _ref2.totalTasks,
      totalCompletedTasks = _ref2.totalCompletedTasks,
      user = _ref2.user,
      company = _ref2.company,
      taskType = _ref2.taskType;

  if (taskType === _constants2.taskTypes.PENDING_TASK) {
    if (totalTasks === totalCompletedTasks) {
      return {
        title: __jsx(_react["default"].Fragment, null, "Great job! You can go to your dashboard.", ' ', __jsx("span", {
          role: "img",
          "aria-label": "Confetti"
        }, "\uD83C\uDF89")),
        description: ''
      };
    }

    return {
      title: 'Please complete these tasks before continuing',
      description: 'We recently made some updates on our platform and we need you to complete the tasks below before continuing to your dashboard.'
    };
  }

  if (totalTasks === totalCompletedTasks) {
    return {
      title: __jsx(_react["default"].Fragment, null, "Great job! You\u2019ve completed your onboarding", ' ', __jsx("span", {
        role: "img",
        "aria-label": "Confetti"
      }, "\uD83C\uDF89")),
      description: __jsx(_react["default"].Fragment, null, "You can manage your information later in your ", __jsx("strong", null, "Personal details"), " page.")
    };
  }

  if (totalCompletedTasks > 0) {
    return {
      title: __jsx(_react["default"].Fragment, null, "Finish activating your account", ' ', __jsx("span", {
        role: "img",
        "aria-label": "Rocket"
      }, "\uD83D\uDE80")),
      description: __jsx(_react["default"].Fragment, null, "Below are all the tasks you need to complete in order to activate your employment with", ' ', company.name, ".")
    };
  }

  return {
    title: __jsx(_react["default"].Fragment, null, "Nice to meet you, ", user.name, ' ', __jsx("span", {
      role: "img",
      "aria-label": "Hand waving"
    }, "\uD83D\uDC4B")),
    description: __jsx(_react["default"].Fragment, null, "Below are all the tasks you need to complete in order to activate your employment with", ' ', company.name, ".")
  };
}

var formatIdentityVerificationTask = function formatIdentityVerificationTask(_ref3) {
  var _ref3$identityTask = _ref3.identityTask,
      identityTask = _ref3$identityTask === void 0 ? {} : _ref3$identityTask,
      inquiryStatus = _ref3.inquiryStatus;
  if ((identityTask === null || identityTask === void 0 ? void 0 : identityTask.status) === _constants2.taskStatus.COMPLETED) return identityTask;

  switch (inquiryStatus) {
    case _constants.personaInquiryStatus.FAILED:
      return {
        status: _constants2.taskStatus.FAILED,
        description: __jsx(_react["default"].Fragment, null, "We weren\u2019t able to verify your identity, please contact help@remote.com")
      };

    case _constants.personaInquiryStatus.PENDING:
    case _constants.personaInquiryStatus.CREATED:
      return {
        status: _constants2.taskStatus.INCOMPLETE
      };

    default:
      return identityTask;
  }
};

exports.formatIdentityVerificationTask = formatIdentityVerificationTask;